import { render, staticRenderFns } from "./TabelaResultadosColegiado.vue?vue&type=template&id=147ee4e2&scoped=true&"
import script from "./TabelaResultadosColegiado.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosColegiado.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosColegiado.vue?vue&type=style&index=0&id=147ee4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ee4e2",
  null
  
)

export default component.exports